import { useQuery } from '@tanstack/react-query'
import { useUnitsString } from './useUnitsString'
import {
  isUserAdminInSociety,
  translateRoles,
  userBoardMemberRoles,
} from '../helpers/society'
import { ISocietiesModel } from '../interfaces/models/societies.interfaces'
import { IUserModel } from '../interfaces/models/users.interfaces'
import { unitQueries } from '../api/units'

export const useUserRoleUnitsString = (
  user: IUserModel | undefined,
  society: ISocietiesModel | undefined
): string[] => {
  const { data: userUnits } = useQuery(unitQueries.getUserUnits(user?._id))
  const unitsString = useUnitsString(
    userUnits?.filter((unit) => unit.societyId === society?._id) || [],
    false
  )

  let userRoles: string[] = []

  if (user && isUserAdminInSociety(society, user._id)) {
    userRoles = [...userRoles, 'admin']
  }

  const _userBoardMemberRoles = user && userBoardMemberRoles(society, user._id)
  if (_userBoardMemberRoles) {
    userRoles = [...userRoles, ..._userBoardMemberRoles]
  }

  const userRoleUnit = [...translateRoles(userRoles), unitsString].filter(
    (_string) => _string
  ) as string[]
  return userRoleUnit
}
